import * as React from 'react';
import { Close } from '@mui/icons-material';
import { Dehaze } from '@mui/icons-material';
import { Button } from '@mui/material';
import "../Pages/Responsive.css"
import Resume from '../Resume/Pranay-Khadse-Resume.pdf'
import Home from '../Pages/Index'
import About from '../Pages/About';
import Skills from '../Pages/Skills';
import Projects from '../Pages/Projects';
import Contact from '../Pages/Contact';
import portfolio from '../Tech Stacks Images/portfolio.png'

function Navbar(){
    let [homeColor,setHomeColor] = React.useState("colorLink")
    let [aboutColor,setAboutColor] = React.useState("Link")
    let [skillsColor,setSkillsColor] = React.useState("Link")
    let [projectColor,setProjectColor] = React.useState("Link")
    let [contactColor,setContactColor] = React.useState("Link")
    let [menu,setMenu] = React.useState(false)
    let [bar,setBar] = React.useState(false)
    
    function changeHomeColor(){
        setHomeColor("colorLink")
        setAboutColor("Link")
        setSkillsColor("Link")
        setProjectColor("Link")
        setContactColor("Link")
        setMenu(false)
        setBar(false)
    }
    function changeAboutColor(){
        setHomeColor("Link")
        setAboutColor("colorLink")
        setSkillsColor("Link")
        setProjectColor("Link")
        setContactColor("Link")
        setMenu(false)
        setBar(false)
    }
    function changeSkillsColor(){
        setHomeColor("Link")
        setAboutColor("Link")
        setSkillsColor("colorLink")
        setProjectColor("Link")
        setContactColor("Link")
        setMenu(false)
        setBar(false)
    }
    function changeProjectColor(){
        setHomeColor("Link")
        setAboutColor("Link")
        setSkillsColor("Link")
        setProjectColor("colorLink")
        setContactColor("Link")
        setMenu(false)
        setBar(false)
    }
    function changeContactColor(){
        setHomeColor("Link")
        setAboutColor("Link")
        setSkillsColor("Link")
        setProjectColor("Link")
        setContactColor("colorLink")
        setMenu(false)
        setBar(false)
    }

    function toggleMenu(){
        setMenu(!menu)
        setBar(!bar)
    }

    function ShowBar(){
      setMenu(false)
      setBar(false)
    }
    const onDownload = () => {
      const link = document.createElement("a");
      link.download = `Pranay-Khadse-Resume.pdf`;
      link.href = Resume;
      link.click();
    }

   function ChangeColor(){
    if(window.scrollY>0 && window.scrollY<150){
      changeHomeColor()
    }
    else if(window.scrollY>580 && window.scrollY<970){
      changeAboutColor()
    }
    else if(window.scrollY>1550 && window.scrollY<3400){
      changeSkillsColor()
    }
    else if(window.scrollY>4000 && window.scrollY<6850){
      changeProjectColor()
    }
    else if(window.scrollY>7450 && window.scrollY<8100){
      changeContactColor()
    }
   }

   window.addEventListener('scroll',ChangeColor)
    
return(
    <div>
    <div className='NavbarContainer'>
    <div className="LogoDiv">
        <a href='#'  className={homeColor} onClick={changeHomeColor}><img src={portfolio} className='Logo'/></a>
    </div>
    <div className={menu?"NavbarOptionsAfter":"NavbarOptions"}>
        <a href='#' className={homeColor} onClick={changeHomeColor}>Home</a>
        <a href='#about' className={aboutColor} onClick={changeAboutColor}>About</a>
        <a href='#skills' className={skillsColor} onClick={changeSkillsColor}>Skills</a>
        <a href='#projects' className={projectColor} onClick={changeProjectColor}>Projects</a>
        <a href='#contacts' className={contactColor} onClick={changeContactColor}>Contact</a>
      <Button href='https://drive.google.com/file/d/14VPFaCIuT8h8yoK4Sw-nViEAIJ6hR6J0/view?usp=sharing' target='_blank' onClick={onDownload} variant="contained" sx={{boxSizing:'border-box',height:'40px'}} >
        Resume
      </Button>
    </div>
    </div>
    {bar?<Close className='MenuBar' onClick={toggleMenu}/>:<Dehaze className='MenuBar'onClick={toggleMenu}/>}
    <div onClick={ShowBar}>
    <a name='' style={{transitionDuration:'1s',transitionDelay:'1s'}}></a>
    <Home/>
    <a name='about'></a>
      <About/>
    <a name='skills'></a>
      <Skills/>
    <a name='projects'></a>
      <Projects/>
    <a name='contacts'></a>
      <Contact/>
      </div>
    </div>
)
}

export default Navbar